import React, { useState, useEffect } from "react";
import AdminDashboard from "../../AdminDashboard"
import { isAuthenticated } from "../../../../auth"
import { updateCollection, updateColor } from "../../apiAdmin"
import { default_url } from "../../../../index"
import { dict } from "../../../../dictionary";
import * as qs from 'query-string';
import { getCollection, listCategories } from "../../../apiCore";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

function UpdateCollection() {
    const classes = useStyles();
    const [values, setValues] = useState({
        _id: "",
        model: "",
        thermos: "",
        thermosTags: "",
        porcelainTags: "",
        accessoriesTags: "",
        porcelain: "",
        accessories: "",
        image: "",
        error: "",
        success: false,
    });
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    const { user, token } = isAuthenticated();
    const { _id, model, thermos, thermosTags, porcelain, porcelainTags, accessories, accessoriesTags, image, error, success } = values;
    const parsed = qs.parse(window.location.search);
    const collectionId = parsed.collection_id;
    if(!collectionId){
        window.location.href = default_url + "admin/collections";
    }

    useEffect(() => {
        async function fetchData() {
            const cats = await listCategories()
                .then(res => {
                    setCategories(res);
                })
                .catch(err => {
                    console.log(err);
                });
        }
        fetchData();
    }, []);

    const loadModel = () => {
        getCollection(collectionId).then(res => {
            if(res.error){
                window.location.href = default_url + "admin/collections";
            }else{
                console.log(res);
                if(!res){
                    window.location.href = default_url + "admin/collections";
                }
                let arr1 = res.thermosTags ? res.thermosTags : []
                let st1 = "";
                for (let i = 0; i < arr1.length; i++) {
                    if(i == arr1.length - 1){
                        st1 += arr1[i]
                    }else{
                        st1 += arr1[i] + " / ";
                    }
                }

                let arr2 = res.porcelainTags ? res.porcelainTags : []
                let st2 = "";
                for (let i = 0; i < arr2.length; i++) {
                    if(i == arr2.length - 1){
                        st2 += arr2[i]
                    }else{
                        st2 += arr2[i] + " / ";
                    }
                }

                let arr3 = res.accessoriesTags ? res.accessoriesTags : []
                let st3 = "";
                for (let i = 0; i < arr3.length; i++) {
                    if(i == arr3.length - 1){
                        st3 += arr3[i]
                    }else{
                        st3 += arr3[i] + " / ";
                    }
                }

                setValues({_id: res._id, model: res.model, thermos: res.thermos, thermosTags: st1, porcelain: res.porcelain, porcelainTags: st2, accessories: res.accessories, accessoriesTags: st3, image: res.image, error: null, success: false});
            }
        })
    }


    useEffect(() => {
        loadModel();
    }, []);

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const clickSubmit = (event) => {
        event.preventDefault();
        let collection = { _id: _id, model: model, thermos: thermos, thermosTags: thermosTags, porcelain: porcelain, porcelainTags: porcelainTags, accessories: accessories, accessoriesTags: accessoriesTags, image: image }
        updateCollection(collection, user._id, token).then(res => {
            if (res.error) {
                setValues({ ...values, error: res.error, success: false });
            } else {
                setValues({ ...values, error: null, success: true });
            }
        })
    }

    const showError = () => {
        return (
            <div className="alert alert-danger" style={{ display: error ? "" : "none", textAlign: 'start' }}>
                {error}
            </div>
        )
    }

    const showSuccess = () => {
        if (success) {
            return (
                <div className="alert alert-info" style={{ textAlign: 'start' }}>
                    {dict['collection_has_been_updated.']} <Link to={default_url + "admin/collections"} style={{ fontSize: "18px" }}>{dict["go_back_to_collections"]}</Link>
                </div>
            )
        }

    }

    const showBackdrop = () => {
        return (
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const CategoriesSelector = feild => {
        return (
            <select onChange={handleChange(feild)} className="inputField form-control" value={feild == "thermos" ? thermos : feild == "porcelain" ? porcelain : accessories}>
                <option value={null}></option>
                {
                    categories.sort((a, b) => a.position - b.position).map((category, index) => {
                        return (
                            <option key={index} value={category._id}>{category.enName + " | " + category.arName}</option>
                        )
                    })
                }
            </select>
        )
    }

    const arStyleRequiredStart = {
        left: "30px"
    }
    const enStyleRequiredStart = {
        right: "30px"
    }
    const arStylelabel = {
        float: "right"
    }
    const enStylelabel = {
        float: "left"
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showBackdrop()}
                {showError()}
                {showSuccess()}
                <h3 className="formContainerTitle">{dict["edit_collection"]}</h3>
                <h6 className="requiredStar requiredStarUserDashbord" style={default_url == "/en/" ? enStyleRequiredStart : arStyleRequiredStart}>{dict["required"]}</h6>
                <form >
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["model_name"]} <span className="redStar">*</span></label>
                    <input onChange={handleChange("model")} type="text" value={model} className="inputField form-control" id="model"></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["thermos"]} <span className="redStar">*</span></label>
                    {CategoriesSelector("thermos")}
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["thermos_tags"]} </label>
                    <input onChange={handleChange("thermosTags")} type="text" value={thermosTags} className="inputField form-control" id="thermosTags"></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["porcelain"]} <span className="redStar">*</span></label>
                    {CategoriesSelector("porcelain")}
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["porcelain_tags"]} </label>
                    <input onChange={handleChange("porcelainTags")} type="text" value={porcelainTags} className="inputField form-control" id="porcelainTags"></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["accessories"]} <span className="redStar">*</span></label>
                    {CategoriesSelector("accessories")}
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["accessories_tags"]} </label>
                    <input onChange={handleChange("accessoriesTags")} type="text" value={accessoriesTags} className="inputField form-control" id="accessoriesTags"></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["model_image"]} <span className="redStar">*</span></label>
                    <input onChange={handleChange("image")} type="text" value={image} className="inputField form-control" id="image"></input>
                    <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["save"]}</button>
                </form>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="4"
            data={form}
        />
    )
}

export default UpdateCollection;